@if(currentView === views.Home) {
  <div class="container">
    <button (click)="getM2Ms(true)" class="request-button">Ver M2Ms</button>

    <button (click)="selectView(views.CreatingM2M)" class="request-button">Crear M2M</button>
  </div>

  <!-- <div class="m2m-searched-container">
    <div class="m2m-search-information">
      <p class="text-info">Devuelve un M2M específico (GET).</p>
      <button (click)="getM2M()">Buscar M2M</button>
      <div class="name-input-container" >
        <input type="text" [(ngModel)]="m2mNameToSearch" class="name-input" placeholder="Nombre">
        @if(m2mNotFound) {
          <p class="m2m-not-found">M2M no encontrado</p>
        }
      </div>
    </div>

    <div class="m2m-searched">
      <p><strong>Nombre: </strong>{{m2mSearched?.nombre ?? ''}}</p>
      <p><strong>Password: </strong>{{m2mSearched?.password ?? ''}}</p>
      <p><strong>FechaPassword: </strong>{{!!m2mSearched ? (m2mSearched.fechaPassword | date:'dd/MM/yyyy HH:mm:ss') : ''}}</p>
      <p><strong>PasswordOld: </strong>{{m2mSearched.passwordOld ?? ''}}</p>
    </div>
  </div> -->
}

@if(currentView === views.M2Ms) {
  <div class="search-container">
    <input type="text" class="search-input" [(ngModel)]="m2mToSearch" (ngModelChange)="onSearchChange()" placeholder="Buscar por nombre">
    <button class="back-button button button-colors" (click)="selectView(views.Home)">Volver</button>
  </div>

  <!-- Vista de M2Ms -->
  <div class="scroll-container">
    @for(m2m of m2ms; track m2m.nombre) {
      <div class="m2m" (click)="selectView(views.M2MDetails, m2m)">
        <div class="m2m-info-container">
          <div class="column">
            <p>{{m2m.nombre}}</p>
          </div>

          <div class="column">
            <p>{{m2m.fechaPassword | date:'dd/MM/yyyy HH:mm:ss'}}</p>
          </div>
        </div>
      </div>
    }
  </div>
}

<!-- Vista de detalles, editar o crear M2M -->
@if(currentView === views.M2MDetails || currentView === views.CreatingM2M || currentView === views.EditingM2M) {
  @if(!!newM2M) {
    <div class="edit-m2m-container">
      <h4>{{currentView === views.M2MDetails ? 'Detalles M2M' : (currentView === views.CreatingM2M ? 'Crear M2M' : 'Editando M2M con nombre "' + (m2mSelected?.nombre ?? '') + '"')}}</h4>

      <div class="input-container">
        <label>Nombre: </label>
        <input type="text" class="new-input" [(ngModel)]="newM2M.nombre" placeholder="Nombre" [readonly]="isReadOnly && currentView !== views.CreatingM2M">
      </div>

      <div class="input-container">
        <label>Contraseña: </label>
        <div class="password-container">
          @if(currentView !== views.CreatingM2M) {
            <label class="password-label">{{showPassword ? newM2M.password : '****'}}</label>

            <button class="details-button button-colors" (click)="changeShowPassword()">{{(showPassword ? 'Ocultar' : 'Mostrar')}}</button>

            <button class="details-button button-colors" (click)="copyToClipboard(newM2M.password)">Copiar</button>

            @if(currentView === views.EditingM2M) {
              <button class="details-button button-colors" (click)="rotatePassword()">Editar contraseña</button>
            }
          } @else {
            <input type="text" class="password-input" [(ngModel)]="newM2M.password" placeholder="Password">
          }
        </div>
      </div>

      @if(currentView !== views.CreatingM2M) {
        <div class="only-text-container">
          <label class="name-info">Fecha de contraseña: </label>
          <label>{{newM2M.fechaPassword | date:'dd/MM/yyyy HH:mm:ss'}}</label>
        </div>

        <div class="only-text-container">
          <label class="name-info">Antigua contraseña: </label>
          <div class="password-container">
            <label class="password-label">{{newM2M.passwordOld ? (showOldPassword ? newM2M.passwordOld : '****' ) : ''}}</label>

            @if(!!newM2M.passwordOld) {
              <button class="details-button button-colors" (click)="changeShowOldPassword()">{{(showOldPassword ? 'Ocultar' : 'Mostrar')}}</button>

              <button class="details-button button-colors" (click)="copyToClipboard(newM2M.passwordOld)">Copiar</button>

              @if(currentView === views.EditingM2M) {
                <button class="details-button button-colors" (click)="revokeOldPassword()">Revocar contraseña</button>
              }
            }
          </div>
        </div>
      }

      <div class="edit-buttons">
        <button class="button button-colors"
          (click)="currentView === views.M2MDetails ? selectView(views.M2Ms) : (currentView === views.CreatingM2M ? selectView(views.Home) : selectView(views.M2MDetails))">
          Volver
        </button>

        @if(currentView === views.M2MDetails) {
          <button class="button button-colors" (click)="deleteM2M()" [disabled]="!globalService.editing">Eliminar M2M</button>
        }

        <button class="button button-colors"
          (click)="currentView === views.M2MDetails ? selectView(views.EditingM2M) : (currentView === views.CreatingM2M ? createM2M() : editM2M())"
          [disabled]="!globalService.editing || newM2M.nombre.trim() === ''">
          {{currentView === views.M2MDetails ? 'Editar' : 'Confirmar'}}
        </button>
      </div>
    </div>
  }
}